import { render } from "./ABiz.vue?vue&type=template&id=996c0a6a"
import script from "./ABiz.vue?vue&type=script&lang=js"
export * from "./ABiz.vue?vue&type=script&lang=js"

import "./ABiz.vue?vue&type=style&index=0&id=996c0a6a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__